const deleteQuicksight = {
  toastr: 'User deleted',
  toastr1: ' successfully deleted'
};

export default deleteQuicksight;
